import { render, staticRenderFns } from "./CustomPaymentCollapse.vue?vue&type=template&id=1b50c574&scoped=true&"
import script from "./CustomPaymentCollapse.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentCollapse.vue?vue&type=style&index=0&id=1b50c574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50c574",
  null
  
)

export default component.exports